import { render, staticRenderFns } from "./FacturaDetail.vue?vue&type=template&id=5279d435&scoped=true&"
import script from "./FacturaDetail.vue?vue&type=script&lang=js&"
export * from "./FacturaDetail.vue?vue&type=script&lang=js&"
import style0 from "./FacturaDetail.vue?vue&type=style&index=0&id=5279d435&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5279d435",
  null
  
)

export default component.exports